import React, { useState } from "react"
import { Form, Input } from "antd"
import { useHistory } from "react-router-dom"
import request from "lib/request"
import { endpoints } from "config/endpoints.config"
import toast from "lib/toast"
import EditEntityCustomFields from "pages/crm/contacts/EditEntityCustomFields"
import FormModal from "components-old/forms/FormModal"
import { channelsDef } from "../channels.def"
import { useSetAtom } from "jotai"
import { modalState } from "atoms/app.atom"

function AddTelegram() {
  const [form] = Form.useForm()
  const history = useHistory()
  const setModal = useSetAtom(modalState)
  return (
    <FormModal
      form={form}
      noPrompt
      onSubmit={(model) => {
        return request.post(endpoints.TELEGRAM, model).then(() => {
          toast.success("Canal de Telegram criado.")
          history.push("/settings/channels")
        })
      }}
      onBack={() => {
        setModal(null)
      }}
      type="drawer"
      width={600}
      titleOverwrite={
        <span className="flex gap-3 items-center text-lg">
          <div className="size-7">{channelsDef.record["telegram"]?.icon}</div>
          Conectar Telegram
        </span>
      }
      hideSuccessMessage
      // stickyFooter
      onSubmitSuccess={() => {
        history.push("/settings/channels")
      }}
      okText="Conectar canal"
    >
      <Form.Item noStyle name="identifier">
        <div></div>
      </Form.Item>
      <Form.Item
        label="Descrição"
        name="description"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input placeholder="Meu canal de Telegram" />
      </Form.Item>
      <Form.Item
        label="Token"
        name="identifier"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <EditEntityCustomFields form={form} entity="channel" />
    </FormModal>
  )
}

export default AddTelegram
